import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {PIXI} from '@colonist/pixi'
import {UIGamePopupSelectDiceView} from './UIGamePopupSelectDiceView'

export class UIGamePopupSelectDiceContainer extends SectionBgView {
    diceViews: UIGamePopupSelectDiceView[]

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, selectedDiceAction: () => void, redDice: boolean) {
        super(x, y, w, h, container)
        this.diceViews = []

        const clickAction = () => {
            selectedDiceAction()
        }

        const padding = h * 0.12
        const diceSize = h - padding * 2
        const totalDiceFaces = 6
        let diceX = padding
        for(let diceNumber = 1; diceNumber <= totalDiceFaces; diceNumber += 1) {
            this.diceViews.push(new UIGamePopupSelectDiceView(this, diceNumber, diceX, padding, diceSize, clickAction, this, redDice))

            diceX += diceSize + padding / 2
        }
    }

    resetAllDice() {
        for(const diceView of this.diceViews) {
            diceView.forceResetOpacity()
        }
    }

    getSelectedDiceNumber(): number | undefined {
        if(!this.isDiceSelected()) return undefined
        for(const diceView of this.diceViews) {
            if(diceView.selected) return diceView.diceNumber
        }
        return undefined
    }

    isDiceSelected(): boolean {
        for(const diceView of this.diceViews) {
            if(diceView.selected) return true
        }
        return false
    }
}
